module.exports = __webpack_public_path__ + "static/media/Mask Group 19.73de1eeb.svg";